export default __webpack_public_path__ + "static/input-border-contrast-b1d48af6bf40f3cf0553dedfc10ffd6b.png";